<template lang="pug">
  ul.hostem-makers-links-columned.columns-2.sm-columns-3.lg-columns-4.text-15.md-text-17(style="column-gap:2rem", v-if="makersLinks.length")
    li.mb-15.md-mb-0(v-for="mkr in makersLinks")
      router-link.hover-text-blue(:to="{name: 'products_collection', params: { collection: mkr.link.post_name }}") {{ mkr.link.post_title }}
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HostemMakersLinksColumned',
  computed: {
    ...mapState({
      makersLinks: state => state.site ? state.site.makers_links : []
    })
  }
}
</script>

<style>
</style>
